import * as PIXI from "pixi.js";
import {app, events, gameData, ticker} from "../utils/pixiApp";
import TWEEN from "@tweenjs/tween.js";
import {getDeviceMedia} from "../utils/sizes";
import {ProgressBar} from "@pixi/ui";

const textStyle = new PIXI.TextStyle({
    fontSize: 24,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fill: '#a1a1a1',
})

const sizes = {
    web: {
        progressWidth: 703,
        progressHeight: 12,
    },
    mobile: {
        progressWidth: 241,
        progressHeight: 6
    }
}

export class Loader extends PIXI.Container {
    constructor() {
        super();
        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.position.set(0,0);
        // this.pivot.set(.5,.5)
        this.progressWidth = 0;
        this.currentProgress = 0;
        this._zIndex = 9000
        this.renderer = app.renderer;
        this.texture =  this.mediaScreen === 'web' ?  PIXI.Texture.from('preloaderDesktop') :  PIXI.Texture.from('preloaderMobile')

        this.appBg = PIXI.Sprite.from(this.texture);
        this.appBg.position.set(0,0);
        this.appBg.setSize(app.screen.width, app.screen.height)

        this.renderTexture = PIXI.RenderTexture.create({width:app.screen.width, height: app.screen.height});
        this.renderTextureSprite = new PIXI.Sprite(this.renderTexture);

        this.addChild(this.appBg)

        this.textLoad = new PIXI.Text({ text: 'Загрузка', style: textStyle });
        this.textLoad.anchor.set(.5,.5)
        this.textLoad.position.set(app.screen.width / 2,  app.screen.height - 94)
        this.addChild(this.textLoad)

        const bg = new PIXI.Graphics()
            .roundRect(0, 0, sizes[this.mediaScreen].progressWidth, sizes[this.mediaScreen].progressHeight, 6)
            .fill('rgba(255, 255, 255, 0.2)');

        const fill = new PIXI.Graphics()
            .roundRect(0,0, sizes[this.mediaScreen].progressWidth, sizes[this.mediaScreen].progressHeight,6)
            .fill('rgba(255, 255, 255, 0.5)')

        this.progressBar = new ProgressBar({bg, fill, progress: 0})
        this.progressBar.position.set(app.screen.width / 2 - sizes[this.mediaScreen].progressWidth / 2,  app.screen.height - 54)

        this.loader = new PIXI.Container()

        this.loader.addChild(this.progressBar)
        this.addChild(this.loader)


        events.onScreenResizeEvent(() => {
            this.setSize(app.screen.width, app.screen.height)
        })

        this.on('SET_PROGRESS', this.setProgress.bind(this))

        this.TWEEN = TWEEN;
        ticker.add(() => this.TWEEN.update())


        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    setProgress(progress) {
        this.progressBar.progress = progress * 100;
        if(progress === 1) {
            if(gameData.getGameData('tokenIsLoad')) {
                setTimeout(this.complete.bind(this), 1000)
            } else {
                events.onLoadToken(this.complete.bind(this))
            }
        }
    }

    complete() {
        this.emit('END_LOAD')
    }

    resizeView() {
        this.mediaScreen = getDeviceMedia(app.screen.width)
        this.texture = this.mediaScreen === 'web' ?  PIXI.Texture.from('preloaderDesktop') :  PIXI.Texture.from('preloaderMobile')
        this.appBg.texture = this.texture
        this.appBg.setSize(app.screen.width, app.screen.height)
        this.textLoad.position.set(app.screen.width / 2,  app.screen.height - 94)
    }
}